const anchorData = {
  about: {
    title: 'Детский клуб развития интеллекта и спорта ABC GYM',
    desc: 'Всестороннее развитие детей от 3 месяцев до 10 лет – занятия спортом, музыкой, английским языком. Физическое, творческое, интеллектуальное развитие вашего ребенка'
  },
  team: {
    title: 'Специалисты детского клуба ABC GYM',
    desc: 'В штате клуба специалисты по раннему развитию, тренеры по гимнастике для разных возрастов, преподаватели музыки, иностранных языков и актеры театральной студии'
  },
  equipment: {
    title: 'О клубе ABC GYM',
    desc: 'Детский клуб имеет два отдельных зала: малый для творческих занятий и большой с пятью зонами под различные спортивные активности.'
  },
  contacts: {
    title: 'ABC GYM – детский центр в Московской области',
    desc: 'Детский клуб и фитнес-центр в ТЦ Ильинский – Московская область, Красногорский район, с. Ильинское, ул. Ленина, д. 11'
  },
  main: {
    title: 'ABC GYM – всестороннее развитие детей от 0 до 10 лет',
    desc: 'Клуб и детский фитнес-центр для комплексного развития двигательной и познавательной активности у детей от 3 месяцев: гимнастика, нейрогимнастика, развитие интеллекта, занятия музыкой, творчеством, английский язык.'
  }
};


const updateMeta = (hash) => {
  let $description = $('meta[name=description]');
  if (!$description.length) {
    $description = $('<meta>').attr({name: 'description'});
    $('head').prepend($description);
  }
  $description.attr({content: anchorData[hash].desc});

  let $title = $('title');
  if (!$title.length) {
    $title = $('<title>');
    $('head').prepend($title);
  }
  $title.html(anchorData[hash].title);
};

let hash = window.location.hash.replace('#', '') || 'main';

updateMeta(hash);

window.onhashchange = () => updateMeta(window.location.hash.replace('#', '') || 'main');




// WEBPACK FOOTER //
// ./src/js/anchor-titles.js